import { ComponentProps } from 'react'

import {
  ThemeProvider as DesignSystemThemeProvider,
  useTheme
} from '@themenu/design-system'
import { SkeletonTheme } from 'react-loading-skeleton'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'

function MergedThemeProvider(
  props: Omit<ComponentProps<typeof StyledThemeProvider>, 'theme'>
) {
  const theme = useTheme()

  return (
    <SkeletonTheme
      baseColor={theme.colors.background.contrast}
      highlightColor={theme.colors.background.default}
      duration={1}
    >
      <StyledThemeProvider theme={theme} {...props} />
    </SkeletonTheme>
  )
}

export function ThemeProvider({
  children,
  ...props
}: ComponentProps<typeof DesignSystemThemeProvider>) {
  return (
    <DesignSystemThemeProvider {...props}>
      <MergedThemeProvider>{children}</MergedThemeProvider>
    </DesignSystemThemeProvider>
  )
}
